import parseNavigation from './parseNavigation';

/** Menú del rol verificador: `tipo id | título | ícono | url`, anidado por tabulación. */
const verifierNavigation = parseNavigation(`
group verifierCertificates | Certificados | verified_user
	item toBeChecked | Certificar transformación | hourglass_empty | /verificator-certified
	item verify-circularity | Verificar circularidad | recycling | /verifier/verify-circularity
	item verified-certificate-avaibles | Certificados disponibles | check_circle_outline | /certificates/verified/avaibles
	item verifier-circularity-available | Certificados de circularidad disponibles | recycling | /circularity/available
	item verifier-circularity-nominations | Certificados de circularidad nominados | how_to_reg | /circularity/consult/nominations
group associatedTransformers | Transformadores asociados | verified_user
	item consult | Consultar | business | /verifier/consult/associated-transformers
group verifier-consults | Consultas | account_tree
	item verifier-certification-info | Certificados aprobados | done_all | /verifier/consult/aprroved-certification
	item verifier-rejected-certification-info | Certificados rechazados | cancel | /verifier/consult/rejected-certification
	item verifier-received-transfer-info | Certificados recibidos | move_to_inbox | /verifier/consult/received-transfer
	item verifier-send-transfer-info | Certificados transferidos | send | /verifier/consult/send-transfer
	item verifier-circularity-certificates | Certificados de circularidad | recycling | /verifier/consult/circularity-certificates
	item verifier-circularity-received | Certificados de circularidad recibidos | move_to_inbox | /circularity/consult/received-transfer
	item verifier-circularity-sent | Certificados de circularidad transferidos | send | /circularity/consult/sent-transfer
`);

export default verifierNavigation;
